module.exports = __webpack_public_path__ + "img/order-status-icon.c5217a69.png";